import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { SpinningLoader } from "@/components/SpinningLoader";
import { PATHS } from "@/constants/paths";
import { useAdminAuth } from "@/hooks/use-admin-auth";

interface IAdminProtectedRouteProps {
  children: ReactNode;
}

export const AdminProtectedRoute = ({
  children,
}: IAdminProtectedRouteProps): ReactNode => {
  const { admin, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background-secondary">
        <SpinningLoader />
      </div>
    );
  }

  if (!admin) {
    return <Navigate to={PATHS.ADMIN.AUTH.SIGN_IN} replace />;
  }

  return <>{children}</>;
};
